import { MapPin } from "lucide-react";
import { STATUS_COLORS, fmtDateTime, pointUrl } from "@/lib/helpers";
import { t } from "@/lib/i18n";

export function Timeline({ history = [], lang = "ro" }) {
  return (
    <ol className="relative space-y-4 border-l border-white/10 pl-5" data-testid="status-timeline">
      {history.map((h, i) => (
        <li key={i} className="relative" data-testid={`timeline-item-${h.status}`}>
          <span
            className="absolute -left-[26px] top-1 h-3 w-3 rounded-full ring-4 ring-[#111827]"
            style={{ background: STATUS_COLORS[h.status] || "#64748B" }}
          />
          <div className="text-sm font-semibold">{t(lang, `status_${h.status}`)}</div>
          <div className="mt-0.5 flex flex-wrap items-center gap-x-3 font-mono text-[11px] text-slate-400">
            <span>{fmtDateTime(h.at)}</span>
            <span>{h.by === "office" ? "Birou" : h.by}</span>
            {h.lat != null && (
              <a href={pointUrl(h.lat, h.lng)} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-blue-400 hover:underline">
                <MapPin className="h-3 w-3" /> GPS
              </a>
            )}
          </div>
        </li>
      ))}
    </ol>
  );
}
